export default __webpack_public_path__ + "beta-maps-example-point-annotation-thumbnail-960-bed6ecb694e84062635c1358f456f7f2.webp";